// features/canvas/utils/text-utils.ts

/**
 * Truncates text to a specified length and adds ellipsis if needed
 * @param text - The text to truncate
 * @param maxLength - Maximum number of characters to display
 * @returns Truncated text with ellipsis if needed
 */
export const truncateText = (text: string, maxLength: number): string => {
  if (!text || text.length <= maxLength) {
    return text;
  }
  return `${text.slice(0, maxLength)}...`;
};

/**
 * Checks if text exceeds the display limit
 * @param text - The text to check
 * @param maxLength - Maximum number of characters
 * @returns Boolean indicating if text needs truncation
 */
export const needsTruncation = (text: string, maxLength: number): boolean => {
  return Boolean(text && text.length > maxLength);
};

/**
 * Gets the display text and tooltip text for a field
 * @param text - The full text
 * @param displayLimit - Maximum characters to display
 * @returns Object with displayText and tooltipText
 */
export const getDisplayText = (text: string, displayLimit: number) => {
  const displayText = truncateText(text, displayLimit);
  const needsTooltip = needsTruncation(text, displayLimit);

  return {
    displayText,
    tooltipText: needsTooltip ? text : null,
    needsTooltip,
  };
};
